import template from './captcha-with-fallback.html';
import controller from './captcha-with-fallback.controller';

import './captcha-with-fallback.styl';

let captchaWithFallbackComponent = {
  restrict: 'E',
  bindings: {
    onInit: '&'
  },
  template,
  controller
};

export default captchaWithFallbackComponent;



// WEBPACK FOOTER //
// ./client/app/common/captcha-with-fallback/captcha-with-fallback.component.js